import { defineActions } from './defineActions'

/**
 * IME appointment. Action names start with Ime.Appointment. (Appointment.* for the shared
 * components under src/components). The footer Save of the Appointment step is
 * Ime.Appointment.Save, declared in ime-page.ts.
 */
export const appointmentActions = defineActions({
  'Ime.Appointment.CancelForReassign': {
    label: 'Reschedule to another specialist (cancel appointment)',
    area: 'Appointment',
    description:
      'Reschedule to Another Specialist > "Do you want to cancel this appointment?" > Yes.',
  },
  'Ime.Appointment.RescheduleDirect': {
    label: 'Reschedule to same specialist (direct change)',
    area: 'Appointment',
    description:
      'Reschedule to Same Specialist > Via Direct Change in Case > Reschedule Now.',
  },
  'Ime.Appointment.RescheduleViaCalendar': {
    label: 'Reschedule to same specialist (via clinic calendar)',
    area: 'Appointment',
    description:
      'Reschedule to Same Specialist > Via Clinic Calendar > pick a session > Reschedule Now.',
  },
  'Ime.Appointment.SyncUhg': {
    label: 'Sync UHG appointment',
    area: 'Appointment',
  },
  'Ime.Appointment.GenerateVideoLink': {
    label: 'Generate video link',
    area: 'Appointment',
  },
  'Ime.Appointment.RemoveSession': {
    label: 'Remove appointment option',
    area: 'Appointment',
    description:
      'Remove on an extra appointment card: releases the session hold. The case itself changes on the next Save.',
  },
  'Appointment.SendRescheduleRequest': {
    label: 'Send reschedule request',
    area: 'Appointment',
    description: 'A case manager asks staff to reschedule the appointment.',
  },
})
